import Vue from 'vue';
import App from './App';
import RouterConfig from './router';
import StoreConfig from './store';

import Fundation from 'fundation-app-vuejs';
import {Router, Store, I18n} from 'fundation-app-vuejs';
import metaDefinition from './store/meta';
import EventBus from './eventBus.js';

import VueGraph from 'vue-graph';
import VuePipeline from 'vue-pipeline';

Vue.prototype.$eventBus = EventBus;

Vue.use(Fundation);
Vue.use(VueGraph);
Vue.use(VuePipeline);

Vue.directive('separator-link', {
    inserted (el, binding, vnode) {
        el.style.position = 'relative';
        let link = document.createElement('div');
        link.style.position = 'absolute';
        link.style.left = '-15px';
        link.style.width = '15px';
        link.style.height = '2px';
        link.style.backgroundColor= '#222';
        if(binding.value){
            link.style.top = binding.value + 'px';
        }else{
            let h = el.clientHeight/2-1;
            link.style.top = h + 'px';
        }
        el.append(link);
    }
});

Vue.directive('scroll-to', {
    inserted (el, binding, vnode) {
        let target = vnode.children.find((child) => {
            return child.key === binding.value;
        });
        if(target){
            target.elm.scrollIntoView();
        }
    }
});

StoreConfig.metaDefinition = metaDefinition;
StoreConfig.apiRootUrl = window.config.api_root_url;

Vue.config.productionTip = false;

/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router: new Router(RouterConfig),
    store: new Store(StoreConfig),
    components: { App },
    template: '<App/>',
    i18n: new I18n(),
});

function translation(key, context){ return app.$t(key, context);}

app.$store.commit('fundation/SET_TRANSLATION_METHOD', translation);

app.$store.dispatch('fundation/changeLang', {lang: 'en', i18n: app.$i18n});

// pour supprimer le loader 1 une fois fundation chargé
let loading1 = document.querySelector('#loading1');
loading1.parentNode.removeChild(loading1);

window.app = app;



// WEBPACK FOOTER //
// ./src/main.js